import { Component, Input, OnInit } from '@angular/core';
import { FormNumberService } from './services/form-number.service';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { IndividualMarketStateStructure } from 'src/app/angular-elements/form-wrappers/plan-enrollment/individual-plan-enrollment-form/configs/interfaces/individualMarket.interfaceStateStructure';

@Component({
    selector: 'app-form-number',
    templateUrl: './form-number.component.html',
    styleUrls: ['./form-number.component.scss'],
    standalone: false
})
export class FormNumberComponent implements OnInit {

  @Input() isSpecialEnrollment: 'true' | 'false';
  formNumber: string;

  constructor(
    private formNumberService: FormNumberService,
    private reducerUtilityService: ReducerUtilityService
  ) { }

  get isSEP(): boolean {
    return this.isSpecialEnrollment === 'true' ? true : false;
  }

  ngOnInit() {
    const individualMarketState: IndividualMarketStateStructure = this.reducerUtilityService.getPayloadStates()?.individualMarket;

    let isChildOnly = false;
    try {
      isChildOnly = individualMarketState?.childOnlyPolicy && individualMarketState?.childOnlyPolicy.toUpperCase() === 'YES';
    } catch (e) {
      isChildOnly = individualMarketState?.childOnlyPolicy as unknown as boolean;
    }

    this.formNumber = this.formNumberService.generateFormNumber(this.isSEP, isChildOnly);
  }

}
